import { CampaignSummaryResult, SortFieldName, SortDirection } from '../campaign';
import { FilteredCampaignActions, FilteredCampaignActionTypes } from './filtered-campaign.actions';

export interface FilteredCampaignState {
    filteredCampaigns: CampaignSummaryResult;
    isLoading: boolean;
    error: string;
}

const initialState: FilteredCampaignState = {
    filteredCampaigns: {
        campaigns: [],
        pagination: { index: 0, size: 10, count: 0 },
        searchInfo: { searchTerm: '' },
        sortingInfo: { fieldName: SortFieldName.empty, direction: SortDirection.none }
    },
    isLoading: false,
    error: ''
};

export function reducer(state = initialState, action: FilteredCampaignActions): FilteredCampaignState {
    switch (action.type) {
        case FilteredCampaignActionTypes.loadCampaignsSuccess:
            return {
                ...state,
                filteredCampaigns: action.payload,
                isLoading: false
            };
        case FilteredCampaignActionTypes.loadCampaignsFail:
            return {
                ...state,
                filteredCampaigns: null,
                isLoading: false,
                error: action.payload
            };
        case FilteredCampaignActionTypes.setIsloadingCampaigns:
            return {
                ...state,
                isLoading: true
            };
        case FilteredCampaignActionTypes.setSearchRequestInfo:
            return {
                ...state,
                filteredCampaigns: {
                    ...state.filteredCampaigns,
                    pagination: action.payload.pagination,
                    searchInfo: action.payload.searchInfo,
                    sortingInfo: action.payload.sortingInfo
                }
            };
        default:
            return state;
    }
}
